import { createAction } from 'redux-actions';

export const TOGGLE_SOUND = 'TOGGLE_SOUND';
export const toggleSound = createAction(TOGGLE_SOUND);

export const CHANGE_THEME = 'CHANGE_THEME';
export const changeTheme = createAction(CHANGE_THEME);

export const SET_NOTIFICATION = 'SET_NOTIFICATION';
export const setNotification = createAction(SET_NOTIFICATION);
